import type {Point} from 'highcharts';

import type {ButtonOption} from 'common/components/popover-card/types';
import {TableColumnType} from 'common/components/data-table/types';

export type PopoverCallback = (
  segment: string,
  path?: string[],
  options?: {highchartsPointContext?: Point; forSegmentColumn?: boolean},
) => ButtonOption[];

export type PopoverActionCallback = (options: {
  segment: string[];
  action: string;
  isTimeComparisonSegment?: boolean;
  color?: string | null;
  columnIndex?: number;
  columnType?: TableColumnType;
}) => void;

export enum PopoverOption {
  Exclude = `exclude`,
  Filter = `filter`,
  ViewEvents = `view_events`,
  ViewUsers = `view_users`,
  ZoomIn = `zoom_in`,
}
